<template>
  <div>
    <div v-if="feedbackList.length != 0">
      <div v-for="(feedback, index) in feedbackList" :key="index" class="myfeedbak_row">
        <div class="acc_trigger mb-2 view_top feedback_top_box" :id="feedback.feedbackId">
          <div class="feedback_title">
            <p @click="showFeedback(feedback.feedbackId)">
              {{ feedback.docTitle }}
              <a :href="feedback.pageId" target="_blank" class="package_view_icon">web</a>
            </p>
            <ul>
              <li>{{ feedback.firstRegDatetime }}</li>
              <li>Ver {{ feedback.versMajor }}.{{ feedback.versMinor }}</li>
              <li>{{ feedback.modelName }}</li>
            </ul>
          </div>
        </div>
        <div class="acc_container" style="display: none">
          <div class="mb-5">
            <div>
              <ul class="view_info">
                <li class="view_category">
                  <em>{{ feedback.userName }}</em
                  ><a href="#" @click="deleteFeedback(feedback)" class="del_bt">Del</a>
                </li>
              </ul>
            </div>
            <div class="feedback_text">
              {{ feedback.content }}
            </div>
          </div>
          <!---->
          <div v-for="(answer, index) in answerList" :key="index">
            <div
              v-if="answer.parentId == feedback.feedbackId"
              class="feedback_answer_box"
            >
              <div class="fa_top">
                <p>{{ answer.userName }} <a href="#" class="del_bt">Del</a></p>
                <p>
                  <span>{{ answer.firstRegDatetime }}</span>
                </p>
              </div>
              <div class="fa_text">{{ answer.content }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="myfeedbak_row text-center pt-5 mt-5">
        <p>
          <em>{{ $t("common.noData") }}</em>
        </p>
      </div>
    </div>
    <div v-if="feedbackList.length != 0" class="paging_nav">
      <div class="paging_nav">
        <a
          href="#"
          v-if="pagingVO.startPage <= pagingVO.blockSize"
          class="page_select prev_page disabled"
          >이전페이지 이동</a
        >
        <a
          v-else
          class="page_select prev_page"
          @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
          v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
          >이전페이지 이동</a
        >
        <span
          v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
          :key="index"
        >
          <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
            pagingVO.startPage + index
          }}</strong>
          <a href="#" v-else @click="searchPage(pagingVO.startPage + index)">{{
            pagingVO.startPage + index
          }}</a>
        </span>
        <a
          v-if="pagingVO.endPage >= pagingVO.totalPage"
          href="#"
          class="page_select next_page disabled"
          >다음페이지 이동</a
        >
        <a
          v-else
          href="#"
          @click="searchPage(pagingVO.endPage + 1)"
          v-bind:data-page="pagingVO.endPage + 1"
          class="page_select next_page"
          >다음페이지 이동</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { getFeedbackList, deleteFeedback } from "@/api/feedback";

export default {
  data() {
    return {
      feedbackList: [],
      feedbackId: "",
      pagingVO: "",
      page: 1,
      isActive: false,
      component: null,
      componentName: null,
      confirmYN: false,
      answerList: [],
    };
  },
  created() {
    this.fetchData(this.page);
    $(".acc_container").hide();
  },
  methods: {
    async fetchData(page) {
      try {
        this.page = page;
        const { data } = await getFeedbackList(this.page);
        this.feedbackList = data.pagingVO.dataList;
        this.pagingVO = data.pagingVO;
        this.answerList = data.answerList;
      } catch (err) {
        console.log(err);
      }
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.page = page;
      this.fetchData(this.page);
    },
    showFeedback(feedbackId) {
      if (
        $("#" + feedbackId)
          .next()
          .is(":hidden")
      ) {
        //If immediate next container is closed...
        $(".acc_trigger").removeClass("active").next().slideUp(); //Remove all .acc_trigger classes and slide up the immediate next container
        $("#" + feedbackId)
          .toggleClass("active")
          .next()
          .slideDown(); //Add .acc_trigger class to clicked trigger and slide down the immediate next container
        // open 된 faq 를 재클릭할 경우 닫힘
      } else if ($("#" + feedbackId).hasClass("active")) {
        $("#" + feedbackId)
          .removeClass("active")
          .next()
          .slideUp();
      }
      return false; //Prevent the browser jump to the link anchor
    },
    async deleteFeedback(feedback) {
      this.confirmYN = confirm(this.$t("alert.delete"));
      if (this.confirmYN) {
        try {
          const response = await deleteFeedback(feedback);
          if (response.data.status) {
            this.feedbackList = [];
            this.pagingVO = "";
            this.answerList = [];
            this.fetchData(this.page);
            $(".acc_container").hide();
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        return;
      }
    },
  },
};
</script>

<style scoped>
.package_view_icon {
  position: absolute;
  right: 10px;
  top: 5px;
  display: block;
  width: 28px;
  height: 28px;
  text-indent: -9999px;
  background: url(../../img/background/package_view_icon.png) no-repeat 50%;
  transition: all 0.3s ease;
}
.feedback_answer_box .fa_top span {
  right: 24px !important;
  margin-left: 10px;
}
.acc_container span {
  position: inherit;
  right: 24px !important;
}
</style>
